import { render, staticRenderFns } from "./minimum-income-container.vue?vue&type=template&id=de3e4750"
import script from "./minimum-income-container.vue?vue&type=script&lang=ts"
export * from "./minimum-income-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports